import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Adal8Service } from 'adal-angular8';
import { interval } from 'rxjs';
import { ObservationService } from '../../../observation/services/observation.service';
import { AuthenticationService } from '../../services/authentication.service';
import { BaseService } from '../../services/base.service';
import { CommonService } from '../../services/common.service';
import { ConstantsService } from '../../services/constants.service';
import { NotificationsService } from '../../services/notification.service';
import { GlobalConstants } from '../../services/GlobalConstants.service';

@Component({
  selector: 'ara-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css'],
})
export class HeaderComponent implements OnInit {
  logoSrc = GlobalConstants.SiteSecondLogoPath;
  isLoginPage = false;
  isUserLoggedIn = false;
  loggedinUserType: string = '';
  loggedInUser: any;
  isDisplaylogobyCompany: boolean;
  companyList: any;
  selectedCompany: any;
  logoutDate: Date = new Date();
  IpAddress: String;
  // activityDate = Date;
  currentLocation: any;
  selectedLang: any;
  storedObs: any = [];
  processedDataCount: number;
  hideRoutes: boolean;
  profileImage: any;
  constructor(
    private adal4Service: Adal8Service,
    private authenticationService: AuthenticationService,
    public baseService: BaseService,
    private commonService: CommonService,
    public translate: TranslateService,
    private notificationsService: NotificationsService,
    private observationService: ObservationService,
  ) {}

  ngOnInit() {
    this.profileImage = 'assets/images/thumb-1@2x.png';
    // if (performance.navigation.type == 1) {
    //   if (this.baseService.getItemFromSession("latestAppVersion") !== "null") {
    //     this.baseService.setItemInSession(
    //       "appVersion",
    //       this.baseService.getItemFromSession("latestAppVersion")
    //     );
    //     this.baseService.setItemInSession("latestAppVersion", null);
    //   }
    // }
    this.currentLocation = location.pathname;
    const loggedInUser = this.baseService.getItemFromSession(
      ConstantsService.commonConstants.loggedInUser,
    );
    this.loggedInUser = JSON.parse(loggedInUser);
    if (
      this.loggedInUser &&
      this.loggedInUser.UserTypeName ===
        ConstantsService.authenticationType.Employee
    ) {
      const apiRequest = {
        Model: {
          ClientId: this.loggedInUser.Company.ClientId,
          ClientSecret: this.loggedInUser.Company.ClientSecret,
          TenantId: this.loggedInUser.Company.TenantName,
          UserId: this.loggedInUser.UserId,
          GroupId: this.loggedInUser.Company.GroupId,
          Email: this.loggedInUser.Email,
        },
      };
      this.commonService.getProfileImage(
        apiRequest,
        this.callbackMethodForProfileImage.bind(this),
      );
    }
    let redirectUri;
    if (window.location.href === ConstantsService.URL.APP) {
      this.isLoginPage = true;
      redirectUri = ConstantsService.URL.APP + ConstantsService.URL.HOMEPAGE;
    } else {
      redirectUri = ConstantsService.URL.APP;
    }
    this.loggedinUserType = this.baseService.getItemFromSession(
      ConstantsService.LoggedInUserType,
    );
    if (
      this.loggedinUserType === ConstantsService.authenticationType.Employee
    ) {
      const employeeLoginResponse = this.baseService.getItemFromSession(
        ConstantsService.EmployeeLoginResponse,
      );
      const validateEmployeeLoginResponse = this.baseService.getItemFromSession(
        ConstantsService.ValidateEmployeeLoginResponse,
      );
      if (
        !employeeLoginResponse &&
        validateEmployeeLoginResponse !== 'failed'
      ) {
        this.adal4Service.handleWindowCallback();
        if (
          this.adal4Service &&
          this.adal4Service.userInfo &&
          this.adal4Service.userInfo.authenticated
        ) {
          this.authenticationService.fetchRequiredUserDetails();
        }
      }
    }
    this.baseService.showRootLoader = false;
    if (loggedInUser) {
      this.isUserLoggedIn = true;
      this.getTranslateLang(this.loggedInUser.Company.CompanyName);
      this.selectedLang = this.loggedInUser.Company.CompanyName;
      // const versionCheck = interval(60000);
      // versionCheck.subscribe(() => {
      //   if (navigator.onLine) {
      //     const apiRequest = {
      //       Model: {
      //         Platform: "WebApp"
      //       }
      //     };
      //     this.commonService.getAppVersion(
      //       apiRequest,
      //       this.callbackMethodForAppVersion.bind(this)
      //     );
      //   }
      // });
      this.processOfflineData();
    } else {
      this.isUserLoggedIn = false;
    }
    const savedIP = this.baseService.getItemFromSession('ipAddress');
    this.IpAddress = savedIP;
    const repeatCheck = interval(1);
    repeatCheck.subscribe((val) => {
      this.currentLocation = location.pathname;
      if (location.pathname.indexOf('masterscreen') > -1) {
        this.hideRoutes = true;
      } else {
        this.hideRoutes = false;
      }
    });
    this.baseService.showRootLoader = false;
  }
  callbackMethodForAppVersion(response) {
    if (response) {
      const appVersion = this.baseService.getItemFromSession('appVersion');
      if (appVersion === null) {
        this.baseService.setItemInSession('appVersion', response.Result);
        this.baseService.setItemInSession('latestAppVersion', null);
      } else if (
        appVersion &&
        appVersion !== 'null' &&
        appVersion !== response.Result
      ) {
        if (
          this.baseService.getItemFromSession('latestAppVersion') === 'null'
        ) {
          this.baseService.setItemInSession('ipAddress', null);
          this.baseService.setItemInSession(
            'latestAppVersion',
            response.Result,
          );
          this.notificationsService.toastNotify(
            'info',
            'Information Message',
            'Update available. Please close this message to get new version',
            true,
          );
        }
      }
    }
  }
  processOfflineData() {
    const processOffline = interval(120000);
    processOffline.subscribe(() => {
      if (navigator.onLine) {
        this.storedObs = JSON.parse(
          this.baseService.getItemFromSession('storedObservations'),
        );
        this.processedDataCount = 0;
        if (
          this.storedObs !== null &&
          this.storedObs !== 'null' &&
          this.storedObs.length > 0
        ) {
          const apiRequest = {
            Model: this.storedObs[this.processedDataCount],
          };
          this.observationService.submitObservationData(
            apiRequest,
            this.callbackMethodForsubmitObservationData.bind(this),
          );
        }
      }
    });
  }
  processObservation(observation) {
    const apiRequest = {
      Model: observation,
    };
    this.observationService.submitObservationData(
      apiRequest,
      this.callbackMethodForsubmitObservationData.bind(this),
    );
  }
  callbackMethodForsubmitObservationData(response) {
    this.processedDataCount++;
    if (this.processedDataCount < this.storedObs.length) {
      this.processObservation(this.storedObs[this.processedDataCount]);
    }
    if (this.processedDataCount === this.storedObs.length) {
      this.notificationsService.toastNotify(
        'info',
        'Information Message',
        'Offline Data Synced successfully',
      );
      this.baseService.setItemInSession('storedObservations', null);
    }
  }
  getTranslateLang(val) {
    this.baseService.setCurrentLanguage(val);
  }
  logout() {
    if (
      this.loggedinUserType === ConstantsService.authenticationType.Employee
    ) {
      if (this.loggedInUser !== null) {
        let UserLogInInformationId = this.baseService.getItemFromSession(
          'UserLogInInformationId',
        );
        this.commonService.saveUserLogInInfo(
          null,
          this.logoutDate,
          this.loggedInUser.UserId,
          UserLogInInformationId,
          this.IpAddress,
        );
      }
      this.authenticationService.logout();
    }
    this.baseService.setItemInSession('UserIndependentPermissions', null);
    window.sessionStorage.clear();
    localStorage.clear();
    window.open(ConstantsService.URL.APP, '_self');
  }
  changePass() {
    this.baseService.navigateToUrl('changepassword');
  }
  fixLoginIssue(): void {
    localStorage.clear();
    window.location.reload();
  }
  callbackMethodForProfileImage(response) {
    if (response && response.Success) {
      this.profileImage = response.Result;
    }
  }
}
